import { type PointBezierHandle } from '..';
import { type Point } from '../../../utils/math';

export const getPathFromPoints = (
  points: Point[],
  bezierHandles: PointBezierHandle[] = [],
  closePath: boolean = true,
) => {
  const path = new Path2D();
  path.moveTo(points[0][0], points[0][1]);
  points.forEach((_, index) => {
    if (index === points.length - 1) return;
    const point = points[index + 1];
    path.bezierCurveTo(
      bezierHandles[index]?.after[0] ?? point[0],
      bezierHandles[index]?.after[1] ?? point[1],
      bezierHandles[index + 1]?.before[0] ?? point[0],
      bezierHandles[index + 1]?.before[1] ?? point[1],
      point[0],
      point[1],
    );
  });
  if (closePath) {
    path.bezierCurveTo(
      bezierHandles[points.length - 1]?.after[0] ?? points[0][0],
      bezierHandles[points.length - 1]?.after[1] ?? points[0][1],
      bezierHandles[0]?.before[0] ?? points[0][0],
      bezierHandles[0]?.before[1] ?? points[0][1],
      points[0][0],
      points[0][1],
    );
  }

  return path;
};

export const getHitPointIndex = (
  points: Point[],
  pos: Point,
  threshold = 10,
) => {
  for (let i = 0; i < points.length; i++) {
    const point = points[i];
    if (
      Math.abs(point[0] - pos[0]) < threshold &&
      Math.abs(point[1] - pos[1]) < threshold
    ) {
      return i;
    }
  }
  return -1;
};
